<template>
	<div>
		<Select :options="status" v-model="selectedStatus" @input="filterStatus" placeholder-prop="Pilih Status" :is-logo="false" :is-sub-label="false" />
	</div>
</template>

<script>
import Select from '../../../components/ui/Select.vue'

export default {
	name: 'FilterStatus',

	components: {
		Select
	},

	data() {
		return {
			status: [],
			selectedStatus: {
				value: 'Semua',
			},
		}
	},

	methods: {
		filterStatus() {
			this.$emit('update:status', this.selectedStatus.value)
		},

		setFilterStatus(data) {
			this.status = data
		}
	}
}
</script>

<style></style>